import { Button, ColumnTypes, Modal, TableWithActions } from '@/components';
import { memo } from 'react';

import TFormSearchForeignBusiness from './form-search-foreign-unit';
import { useLogic } from './logic';
import { SelectForeignUnitModalViewProps } from './type';

const SelectForeignBusinessModal = (props: SelectForeignUnitModalViewProps) => {
	const { ...rest } = props;

	const {
		dataSource,
		columns,
		rowSelection,
		searchFilterRef,
		openModal,
		onToggle,
		handleSave,
		filter,
		handleChangeSelect,
		handleChangeKeyword,
		handleSelectNational,
		onSearch,
		loading,
		isSearching,
		isSaving,
	} = useLogic(props);

	return (
		<div className={props?.containerClassName}>
			<Button secondary onClick={onToggle} className={props?.btnClassName}>
				{props?.textBtn || '추가'}
			</Button>
			<Modal
				open={openModal}
				onCancel={onToggle}
				labelButton="완료"
				onClickButton={handleSave}
				title="해외 사업체 선택"
				loading={isSaving}
				{...rest}
			>
				<div className="bg-white">
					<TFormSearchForeignBusiness
						{...{
							filter,
							handleChangeSelect,
							handleChangeKeyword,
							handleSelectNational,
							onSearch,
						}}
					/>
					<TableWithActions
						{...{ loading, isSearching }}
						actionHidden
						columns={columns as ColumnTypes}
						dataSource={dataSource}
						rowSelection={{ ...rowSelection }}
						scroll={{ y: 400 }}
						rowKey={'id'}
						searchFilterRef={searchFilterRef}
						containerClassName="px-0"
					/>
				</div>
			</Modal>
		</div>
	);
};

export default memo(SelectForeignBusinessModal);
